import React, { useState, useRef } from 'react';
import './ComparisonSlider.css';

const ComparisonSlider = ({ before, after }) => {
    const [sliderPos, setSliderPos] = useState(50);
    const containerRef = useRef(null);

    const handleMove = (e) => {
        if (!containerRef.current) return;

        // Handle both Mouse and Touch
        const clientX = e.clientX || (e.touches && e.touches[0].clientX);
        if (clientX === undefined) return;

        const rect = containerRef.current.getBoundingClientRect();
        const x = clientX - rect.left;
        let position = (x / rect.width) * 100;

        if (position < 0) position = 0;
        if (position > 100) position = 100;
        setSliderPos(position);
    };

    const handleLeave = () => {
        // Optionnel: On peut choisir de laisser le slider là où il est
        // ou de le remettre au milieu. Le "au milieu au survol" suggère
        // peut-être une réinitialisation.
        // setSliderPos(50); 
    };

    return (
        <div
            className="comparison-slider"
            ref={containerRef}
            onMouseMove={handleMove}
            onTouchMove={handleMove}
            onMouseLeave={handleLeave}
        >
            {/* Background Image (After) */}
            <div className="img-after" style={{ backgroundImage: `url(${after})` }}></div>

            {/* Foreground Image (Before) - Clipped */}
            <div
                className="img-before"
                style={{
                    backgroundImage: `url(${before})`,
                    width: '100%',
                    clipPath: `inset(0 ${100 - sliderPos}% 0 0)`
                }}
            ></div>

            {/* Handle - Follows mouse without click */}
            <div
                className="slider-handle"
                style={{
                    left: `${sliderPos}%`,
                    transition: 'none' // Direct follow for reaction speed
                }}
            >
                <div className="handle-circle">
                    <div className="ba-arrow-left"></div>
                    <div className="ba-arrow-right"></div>
                </div>
            </div>

            <div className="label b-label">AVANT</div>
            <div className="label a-label">APRÈS</div>
        </div>
    );
};

export default ComparisonSlider;
